import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import urls from '../../../../networkRequests/apiClient/endpoints'
import errorHandler from '../../../../shared/functions/ErrorHandler/errorHandler.functions'
import { ApiErrorResponse } from '../../../../shared/types/api.types'
import { validateDiscountCodeApi } from './validateDiscountCode.api'
import { validateDiscountCodeInitialState } from './validateDiscountCode.initialState'
import { ValidateDiscountCodeErrorResponse, ValidateDiscountCodeRequestPayload } from './validateDiscountCode.types'

// Async thunk creation
export const validateDiscountCode = createAsyncThunk(
  urls.payments.validateDiscountCode,
  async (payload: ValidateDiscountCodeRequestPayload, { rejectWithValue }) => {
    const { request, onSuccess } = payload

    try {
      const response = await validateDiscountCodeApi(request)
      onSuccess && onSuccess()

      return response
    } catch (error) {
      errorHandler.handleApiError(error as ApiErrorResponse)

      return rejectWithValue(error)
    }
  }
)

// Slice creation
const validateDiscountCodeSlice = createSlice({
  name: urls.payments.validateDiscountCode,
  initialState: validateDiscountCodeInitialState,
  reducers: {
    resetValidateDiscountCode: (state) => {
      state.loading = false
      state.error = null
      state.success = null
      state.validationStatus = 'idle'
      state.lastValidatedCode = null
    },
    setValidationStatus: (state, action) => {
      state.validationStatus = action.payload
    },
    setLastValidatedCode: (state, action) => {
      state.lastValidatedCode = action.payload
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(validateDiscountCode.pending, (state, action) => {
        state.loading = true
        state.error = null
        state.success = null
        state.validationStatus = 'validating'
        state.lastValidatedCode = action.meta.arg.request.code
      })
      .addCase(validateDiscountCode.fulfilled, (state, { payload }) => {
        state.loading = false
        state.success = payload
        state.error = null
        state.validationStatus = payload.data.isValid ? 'valid' : 'invalid'
      })
      .addCase(validateDiscountCode.rejected, (state, { payload }) => {
        state.loading = false
        state.error = payload as ValidateDiscountCodeErrorResponse
        state.success = null
        state.validationStatus = 'invalid'
      })
  }
})

// Exports
export const { actions: validateDiscountCodeActions, reducer: validateDiscountCodeReducer } = validateDiscountCodeSlice
export const { resetValidateDiscountCode, setValidationStatus, setLastValidatedCode } = validateDiscountCodeActions

export default validateDiscountCodeSlice.reducer
